/* global $ */
$(document).foundation()
